import { render, staticRenderFns } from "./fbtzAdd.vue?vue&type=template&id=a6508fca&"
import script from "./fbtzAdd.vue?vue&type=script&lang=js&"
export * from "./fbtzAdd.vue?vue&type=script&lang=js&"
import style0 from "./fbtzAdd.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports